<template>
  <div class="tab-bar">

    <TabBarItem v-for="(item) in tabs" :key="item.path" :text="item.text" @click="tabClicked(item)"
      :active="isActive(item)">
      <template #icon>
        <component :is="item.icon">
        </component>
      </template>
    </TabBarItem>
  </div>
</template>

<script setup lang="ts">
import TabBarItem from '@/components/TabBarItem.vue'
import { hapticService } from '@/services/haptic.service'
import { useRouter } from 'vue-router';
defineProps(['tabs'])

const router = useRouter()
const tabClicked = (tab: any) => {
  router.push({
    name: tab.routeName
  })
  hapticService.vibrate()
}

const isActive = (tab: any) => tab.routeName === router.currentRoute.value.name
</script>

<style lang="scss" scoped>
.tab-bar {
  display: flex;
  justify-content: space-around;
  align-items: center;

  .tab-bar-item {
    width: 25%;
    z-index: 2;
  }
}
</style>
